import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React__default, { useState, useEffect } from 'react';
import './Switch.scss.js';
import { classnames } from '../../../utils/classnames.js';

var Switch = function Switch(_ref) {
  var label = _ref.label,
      helperText = _ref.helperText,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? false : _ref$value,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onChange = _ref.onChange,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      _ref$reverse = _ref.reverse,
      reverse = _ref$reverse === void 0 ? false : _ref$reverse,
      _ref$between = _ref.between,
      between = _ref$between === void 0 ? false : _ref$between;

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      s = _useState2[0],
      toggle = _useState2[1];

  useEffect(function () {
    toggle(value);
  }, [value]);

  var changeState = function changeState() {
    if (!disabled) {
      onChange && onChange(!s);
      toggle(!s);
    }
  };

  return /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: classnames('rf-switch', "rf-switch--".concat(size), disabled && 'rf-switch--disable', reverse && 'rf-switch--reverse', between && 'rf-switch--between'),
    onClick: changeState,
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "rf-switch__toggle ".concat(s ? 'on' : 'off'),
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "rf-switch__circle",
    "data-v-6e52f9c7": ""
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "rf-switch__content",
    "data-v-6e52f9c7": ""
  }, label && /*#__PURE__*/React__default.createElement("p", {
    className: "rf-switch__label",
    "data-v-6e52f9c7": ""
  }, label), helperText && /*#__PURE__*/React__default.createElement("p", {
    className: "rf-switch__helper-text",
    "data-v-6e52f9c7": ""
  }, helperText)));
};

export { Switch as default };
